export const SUPER_ADMIN_AUM_USER_ID = "AA0001";

/** Set false to hide Analytics Dashboard (/analytics) for admin users in nav and redirects. */
export const SHOW_ADMIN_ANALYTICS_DASHBOARD = false;

export const canAccessSuperAdminFeatures = (
  aumUserId: string = ""
): boolean =>
  (aumUserId || "").trim() === SUPER_ADMIN_AUM_USER_ID;

export const getAdminHomeRoute = (aumUserId: string = ""): string =>
  canAccessSuperAdminFeatures(aumUserId)
    ? "/super-admin/ops-dashboard"
    : "/investor";
